
// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import MDInput from "common/components/MD/MDInput";
import MDTypography from "common/components/MD/MDTypography";
import SectionTitle from "common/components/mycomponents/SectionTitle";

import PropTypes from "prop-types";
import { useEffect } from "react";

function ExpoRichiesteVis({ prop }) {


   let coppie=[];


  if (prop?.specie_quanti) {
  coppie = prop.specie_quanti
    .split('|')
    .map((item) => {
      const [specie, quanti] = item.split(',').map(s => s.trim());
      return {
        specie,
        quanti: Number(quanti) || 0
      };
    });
}


  return (
    <MDBox>
      <MDBox mb={4}>
      <SectionTitle title="DATI ANAGRAFICI"></SectionTitle>
       
      </MDBox>

      <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr' }}>
        <MDBox>
          <MDInput type="text" label="Ragione Sociale" name='ragione_sociale' fullWidth readOnly value={prop.ragione_sociale??''}  InputLabelProps={{ shrink: Boolean(prop.ragione_sociale) }} />
        </MDBox>
        <MDBox>
          <MDInput type="text" label="Legale Rappresentante" name='rappresentante_legale' fullWidth readOnly value={prop.rappresentante_legale??''}  InputLabelProps={{ shrink: Boolean(prop.rappresentante_legale) }}/>
        </MDBox>
      </MDBox>

      <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr' }}>
        <MDBox >
          <MDInput type="text" fullWidth readOnly label="Indirizzo" required name='indirizzo' value={prop.indirizzo?? ''}  InputLabelProps={{ shrink: Boolean(prop.indirizzo) }} />
        </MDBox>
        <MDBox>
          <MDInput type="text" fullWidth readOnly label="civico" required name='civico' value={prop.civico ?? ''}  InputLabelProps={{ shrink: Boolean(prop.civico) }}/>
        </MDBox>
      </MDBox>

      <MDBox mb={2} >
        <MDInput type="text" label="Dettaglio Indirizzo (frazione, c/o, piano, ...)" fullWidth readOnly name='indirizzo2' value={prop.indirizzo2}  InputLabelProps={{ shrink: Boolean(prop.indirizzo2) }} />
      </MDBox>
      <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 8fr 1fr' }}>

        <MDBox>
          <MDInput type="text" label="CAP" fullWidth readOnly name='cap' value={prop.cap??''}  InputLabelProps={{ shrink: Boolean(prop.cap) }}/>
        </MDBox>
        <MDBox>
          <MDInput type="text" label="località" name='localita' fullWidth readOnly value={prop.localita??''}  InputLabelProps={{ shrink: Boolean(prop.localita) }} />
        </MDBox>
        <MDBox>
          <MDInput type="text" label="provincia" name='provincia' fullWidth readOnly value={prop.provincia??''}  InputLabelProps={{ shrink: Boolean(prop.provincia) }}/>
        </MDBox>
      </MDBox>

      <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr 1fr' }}>
        <MDBox>
          <MDInput type="text" label="Codice Fiscale" name='cf' fullWidth readOnly value={prop.cf??''}  InputLabelProps={{ shrink: Boolean(prop.cf) }} />
        </MDBox>
        <MDBox>
          <MDInput type="text" label="Partita IVA" name='piva' fullWidth readOnly value={prop.piva??''}  InputLabelProps={{ shrink: Boolean(prop.piva) }} />
        </MDBox>
       <MDBox>
          <MDInput type="text" label="Telefono" name='telefono' fullWidth  readOnly value={prop.telefono??''}  InputLabelProps={{ shrink: Boolean(prop.telefono) }}/>
                      </MDBox>
                      <MDBox>
                        <MDInput type="text" label="Fax" name='fax' fullWidth readOnly value={prop.fax??''}  InputLabelProps={{ shrink: Boolean(prop.fax) }}/>
                      </MDBox>

                      <MDBox>
                        <MDInput type="text" label="WWW" name='www' fullWidth  readOnly value={prop.www??''}  InputLabelProps={{ shrink: Boolean(prop.www) }}/>
                      </MDBox>
                      <MDBox>
                        <MDInput type="text" label="Email" fullWidth  name='email' readOnly value={prop.email ?? '' }  InputLabelProps={{ shrink: Boolean(prop.email) }}/>
                      </MDBox>

                      <MDBox>
                        <MDInput type="text" label="PEC" name='pec' fullWidth  readOnly value={prop.pec??''}  InputLabelProps={{ shrink: Boolean(prop.pec) }}          />
                      </MDBox>
                      <MDBox>
                        <MDInput type="text" label="Codice SDI" fullWidth  name='codice_sdi'  readOnly value={prop.codice_sdi ?? ''}  InputLabelProps={{ shrink: Boolean(prop.codice_sdi) }}/>
                      </MDBox>

                      <MDBox>
                        <MDInput type="text" label="Responsabile Fiera" name='responsabile_fiera' fullWidth  readOnly value={prop.responsabile_fiera ?? ''}  InputLabelProps={{ shrink: Boolean(prop.responsabile_fiera) }}/>                    
                      </MDBox>
                      <MDBox>
                        <MDInput type="text" label="Telefono Responsabile" fullWidth  name='telefono_resp' readOnly value={prop.responsabile_fiera_telefono??''}  InputLabelProps={{ shrink: Boolean(prop.responsabile_fiera_telefono) }} />
                      </MDBox>

                      <MDBox>
                        <MDInput type="text" label="Cellulare" name='cell_resp' fullWidth  readOnly value={prop.responsabile_fiera_cell??''}  InputLabelProps={{ shrink: Boolean(prop.responsabile_fiera_cell) }} />
                        </MDBox>

                       <MDBox>
                        <MDInput type="text" label="Email (Da utilizzare per le comunicazioni dirette)" fullWidth  name='email_resp'  readOnly value={prop.responsabile_fiera_email??''}  InputLabelProps={{ shrink: Boolean(prop.responsabile_fiera_email) }} />
                      </MDBox>
        
                 
                      <MDBox>
                        <MDInput type="text" label="IBAN (Per l'eventuale restituzione dell'anticipo versato)" fullWidth  name='iban'  readOnly value={!prop.isEstero?prop.iban:(prop.iban2+"-SWIFT:"+prop.swift)}  InputLabelProps={{ shrink: Boolean(prop.iban || prop.iban2) }} />
                      </MDBox>
                      {(!prop.avi) &&
                      <MDBox>
                      <MDInput type="text" label="CODICE MERCEOLOGIC0 1" fullWidth  readOnly 
                      value={prop.cm_01?(prop.cm_01+"-"+prop.cm_01_descrizione):'/'}/>
                                                                                                   
                     </MDBox>}
                        {(!prop.avi) &&
                     <MDBox>
                      <MDInput type="text" label="CODICE MERCEOLOGIC0 2" fullWidth  readOnly 
                      value={
                        (prop.cm_02?(prop.cm_02+"-"+prop.cm_02_descrizione):'/')}/>
                                                                                                   
                     </MDBox>}
   {(!prop.avi) &&
                     <MDBox>
                      <MDInput type="text" label="CODICE MERCEOLOGIC0 3" fullWidth  readOnly 
                      value={
                        prop.cm_03?(prop.cm_03+"-"+prop.cm_03_descrizione):'/'}/>
                                                                                                   
                     </MDBox>}
                      {(!prop.avi) &&
                     <MDBox>
                      <MDInput type="text" label="CODICE MERCEOLOGIC0 4" fullWidth  readOnly 
                      value={
                        prop.cm_04?(prop.cm_04+"-"+prop.cm_04_descrizione):'/'}/>
                                                                                                   
                     </MDBox>}


                     </MDBox>
    

                     <MDBox>
                        <MDInput type="text" label={!prop.avi?"Prodotti / Servizi in esposizione (descrivere in maniera dettagliata)":"Animali da esporre"} fullWidth readOnly
                          name='prodotti_servizi' value={prop.prodotti_servizi??''} multiline rows={5}  InputLabelProps={{ shrink: Boolean(prop.prodotti_servizi) }} />
                     </MDBox>

                    {prop.avi && 
                        <MDBox mb={2} mt={4} sx={{ width: '100%' }}>
                      
                                              <MDBox mb={4}>
                      
                                                <MDButton variant="gradient" color="success" fullWidth>
                                                  <MDTypography variant="h5" fontWeight="regular" sx={{ color: "#FFFFFF" }}>Conigli, Polli, Animali da Cortile, Selvaggina, etc...</MDTypography>
                                                </MDButton>
                                              </MDBox>
                      
                                              <MDBox>
                          {coppie[0].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_0' fullWidth  readOnly value={coppie[0].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[0].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_0' fullWidth  readOnly value={coppie[0].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[0].quanti) }} />
                                                </MDBox>}
                                                 {coppie[1].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_1' fullWidth  readOnly value={coppie[1].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[1].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_1' fullWidth readOnly value={coppie[1].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[1].quanti) }} />
                                                </MDBox>}
                                                 {coppie[2].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_2' fullWidth  readOnly value={coppie[2].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[2].specie) }}/>
                                                  <MDInput type="text" label="Capi n°" name='quanti_2' fullWidth readOnly value={coppie[2].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[2].quanti) }} />
                                                </MDBox>}
                                                 {coppie[3].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_3' fullWidth  readOnly value={coppie[3].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[3].specie) }}/>
                                                  <MDInput type="text" label="Capi n°" name='quanti_3' fullWidth readOnly value={coppie[3].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[3].quanti) }} />
                                                </MDBox>}
                                                 {coppie[4].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_4' fullWidth  readOnly value={coppie[4].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[4].specie) }}/>
                                                  <MDInput type="text" label="Capi n°" name='quanti_4' fullWidth readOnly value={coppie[4].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[4].quanti) }} />
                                                </MDBox>}
                                                 {coppie[5].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_5' fullWidth  readOnly value={coppie[5].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[5].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_5' fullWidth readOnly value={coppie[5].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[5].quanti) }} />
                                                </MDBox>}
                                                 {coppie[6].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_6' fullWidth readOnly value={coppie[6].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[6].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_6' fullWidth  readOnly value={coppie[6].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[6].quanti) }} />
                                                </MDBox>}
                                                 {coppie[7].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_7' fullWidth  readOnly value={coppie[7].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[7].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_7' fullWidth  readOnly value={coppie[7].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[7].quanti) }} />
                                                </MDBox>}
                                                 {coppie[8].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_8' fullWidth readOnly value={coppie[8].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[8].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_8' fullWidth  readOnly value={coppie[8].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[8].quanti) }} />
                                                </MDBox>}
                                                 {coppie[9].specie &&
                                                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>
                                                  <MDInput type="text" label="Specie" name='specie_9' fullWidth readOnly value={coppie[9].specie ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[9].specie) }} />
                                                  <MDInput type="text" label="Capi n°" name='quanti_9' fullWidth  readOnly value={coppie[9].quanti ?? ''}  InputLabelProps={{ shrink: Boolean(coppie[9].quanti) }} />
                                                </MDBox>
}
                      
                                              </MDBox>
                      
                      
                                            </MDBox>
                    }


                     <MDBox mt={2} mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr ' }}>
                     <MDBox>
                        <MDInput type="text" label="Note" fullWidth readOnly
                          name='note' value={prop.note??''} multiline rows={5}  InputLabelProps={{ shrink: Boolean(prop.note) }}/>
                     </MDBox>
                     <MDBox>
                        <MDInput type="text" label="Esigenze Espositive" fullWidth readOnly
                          name='esigenze_espositive' value={prop.esigenze_espositive??''} multiline rows={5}  InputLabelProps={{ shrink: Boolean(prop.esigenze_espositive) }}/>
                     </MDBox>
                      
                      </MDBox>


    </MDBox>
  );

}


ExpoRichiesteVis.defaultProps = {
  prop: null
};

ExpoRichiesteVis.propTypes = {
  prop: PropTypes.object
};

export default ExpoRichiesteVis;
